import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, Subject } from "rxjs";
import { delay, exhaustMap, tap } from "rxjs/operators";

class BaseCacheDistribution {
  resultReturnSubject = new ReplaySubject(1);
  getRequestSubject = new Subject();
  loadLeadDefaultLoaded = false;

  constructor(private clientWithUrlObservable: any) {
    this.getRequestSubject
      .pipe(
        exhaustMap(() => {
          return this.clientWithUrlObservable;
        }),
        tap(() => {
          this.loadLeadDefaultLoaded = true;
        })
      )
      .subscribe(
        (res) => {
          this.resultReturnSubject.next(res);
          this.resultReturnSubject.complete();
        },
        (res) => {
          this.resultReturnSubject.error(res);
        }
      );
  }

  public getResult() {
    if (this.loadLeadDefaultLoaded) {
      return this.resultReturnSubject.asObservable().pipe(delay(0));
    }

    this.getRequestSubject.next();

    return this.resultReturnSubject.asObservable();
  }
}

@Injectable({
  providedIn: "root",
})
export class CacheService {
  cache = new Map();

  cacheRequest(name, ob: Observable<any>, forceReload = false) {
    if (!forceReload && this.get(name)) {
      return this.get(name);
    } else {
      const distribution = new BaseCacheDistribution(ob);
      this.set(name, distribution);

      return this.get(name);
    }
  }

  get(name) {
    return this.cache.get(name);
  }

  set(key, value) {
    return this.cache.set(key, value);
  }
}
